import { LegendList, LegendListProps } from "@legendapp/list/react"
import { ScrollView } from "react-native"

export { ScrollView }

export const List = <T,>(props: LegendListProps<T>) => {
  return <LegendList recycleItems {...props} />
}
